/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedcourselocation2Inputs */

const en__field_inheritedcourselocation2 = /** @type {(inputs: _Field_Inheritedcourselocation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`course Location (inherited)`)
};

const de__field_inheritedcourselocation2 = /** @type {(inputs: _Field_Inheritedcourselocation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurs Ort (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "course Location (inherited)" |
*
* @param {_Field_Inheritedcourselocation2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedcourselocation2 = /** @type {((inputs?: _Field_Inheritedcourselocation2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedcourselocation2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedcourselocation2(inputs)
	return de__field_inheritedcourselocation2(inputs)
});
export { _field_inheritedcourselocation2 as "_field_inheritedCourseLocation" }